import React from 'react';
import {Select} from 'antd';
import {CloseOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import classes from '../courses.module.css';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';
import {FILTER_GROUPS} from '../courses.enums';
import {programsLabel} from '../courses.utils';

/**
 * Липкая панель фильтров каталога — три выпадающих списка с множественным выбором.
 *
 * Раньше здесь были ряды чипов: на три группы их набиралось четырнадцать штук в два
 * ряда, панель съедала треть первого экрана и на узких окнах разъезжалась. Селект
 * занимает одно и то же место независимо от количества значений и сам умеет
 * схлопываться, поэтому отдельная мобильная шторка больше не нужна.
 *
 * Из четырёх напрашивавшихся фильтров оставлены три: направление, формат, уровень.
 * «Длительность» выброшена — 16 часов у девяти программ из двенадцати, такой фильтр
 * ничего не режет. «Для кого» выброшено — роли слишком дробные.
 */
const FilterBar = ({selected, counts, setGroup, reset, hasActiveFilters, found, total}) => {
    const {t} = useTranslation();

    return (
        <div className={classes.filterBar}>
            <div className={classes.filterInner}>
                {FILTER_GROUPS.map((group) => (
                    <Select
                        key={group.key}
                        className={classes.filterSelect}
                        mode="multiple"
                        allowClear
                        maxTagCount="responsive"
                        size="large"
                        value={selected[group.key]}
                        onChange={(values) => setGroup(group.key, values)}
                        placeholder={t(group.titleKey)}
                        aria-label={t(group.titleKey)}
                        options={group.options.map((option) => {
                            const count = counts[group.key]?.[option.code] ?? 0;
                            const isSelected = selected[group.key].includes(option.code);
                            return {
                                value: option.code,
                                // Значение без результатов не прячем, а гасим:
                                // границы ассортимента должны быть видны
                                disabled: count === 0 && !isSelected,
                                label: (
                                    <span>
                                        {t(option.labelKey)}
                                        <span className={classes.optionCount}>{count}</span>
                                    </span>
                                ),
                            };
                        })}
                    />
                ))}

                <div className={classes.filterTail}>
                    <span className={classes.counter} aria-live="polite">
                        {found === total
                            ? programsLabel(total)
                            : t('coursesPage.counter.filtered', {found, total})}
                    </span>
                    {hasActiveFilters && (
                        <button type="button" className={classes.resetBtn} onClick={reset}>
                            <CloseOutlined style={{fontSize: 11}}/>
                            <IntlMessage id="coursesPage.filters.reset"/>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FilterBar;
